import * as angular from 'angular';

import { Helper } from '../../common/helpers/helper';
import { ComponentDefinition } from '../../models';

class SymbolPickerController implements angular.IComponentController {
    symbols: string[];

    static $inject = [];

    $onInit() {
        this.symbols = Helper.getSymbols();
    }
}

export const wtSymbolPicker: ComponentDefinition = {
    componentId: 'wtSymbolPicker',
    controller: SymbolPickerController,
    template: require('./symbolPicker.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=',
        disabled: '<?'
    }
};
